import Styled from 'styled-components';

export const ButtonColor = Styled.button`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: max-content !important;
  border-radius:  5px;
  border-color: transparent;
  // font-weight: bold;
  padding-inline: 10px;
  background: ${props => props.theme.test.color3};
  color: ${props => props.theme.textColors.secundary};
  font-size: ${props => props.theme.fontSize.mediun};
  height: 45px !important; 
  text-transform: uppercase !important;

  &:hover {
      opacity: 0.9;
  };
  `;